import axios from 'axios';
import { store } from '../store';
import { logout } from '../features/auth/authSlice';
import environment from '../config/environment';
import Cookies from 'js-cookie';

// Create axios instance with timeout and retry configuration
const api = axios.create({
  baseURL: environment.API_BASE_URL,
  timeout: environment.API_TIMEOUT || 30000, // Use environment timeout or default to 30 seconds
  headers: {
    'Content-Type': 'application/json',
  }
}); 

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get('Token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token expiration and network errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Handle network errors
    if (error.code === 'ERR_NETWORK' || error.message === 'Network Error') {
      console.error('Network error detected:', error);
      // Don't redirect for network errors, let the component handle them
      return Promise.reject(error);
    }
    
    // Handle incomplete chunked encoding
    if (error.message && error.message.includes('ERR_INCOMPLETE_CHUNKED_ENCODING')) {
      console.error('Incomplete chunked encoding error:', error);
      return Promise.reject(error);
    }
    
    // Handle timeout errors
    if (error.code === 'ECONNABORTED') {
      console.error('Request timeout:', error);
      return Promise.reject(error);
    }
    
    // Handle 401 Unauthorized
    if (error.response?.status === 401) {
      console.error('Token expired or invalid');
      store.dispatch(logout());
      window.location.href = '/login';
      return Promise.reject(error);
    }
    
    // Handle other HTTP errors
    if (error.response) {
      console.error('HTTP error:', error.response.status, error.response.data);
    }
    
    return Promise.reject(error);
  }
);

export default api; 